// Unique avatar based on user name - generates unique color per user
const AVATAR_COLORS = [
  ['#FF2A6D', '#FF6B9D'], ['#05D9E8', '#40E0D0'], ['#FFD700', '#FFA500'],
  ['#01FFC3', '#00E676'], ['#AB47BC', '#CE93D8'], ['#FF6B35', '#FF8F60'],
  ['#536DFE', '#8C9EFF'], ['#E91E63', '#F48FB1'], ['#00BCD4', '#4DD0E1'],
  ['#8BC34A', '#AED581'], ['#FF5722', '#FF8A65'], ['#3F51B5', '#7986CB'],
  ['#009688', '#4DB6AC'], ['#FFC107', '#FFD54F'], ['#795548', '#A1887F'],
  ['#607D8B', '#90A4AE'], ['#F44336', '#E57373'], ['#2196F3', '#64B5F6'],
  ['#4CAF50', '#81C784'], ['#9C27B0', '#BA68C8'],
];

function getColorFromName(name) {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getInitials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name[0].toUpperCase();
}

export function UserAvatar({ name, size = 40, className = '' }) {
  const [c1, c2] = getColorFromName(name);
  const initials = getInitials(name);
  const fontSize = size * 0.4;

  return (
    <div
      data-testid="user-avatar"
      className={`flex items-center justify-center rounded-full font-black select-none ${className}`}
      style={{
        width: size, height: size, minWidth: size,
        background: `linear-gradient(135deg, ${c1}, ${c2})`,
        fontSize, color: '#fff', fontFamily: 'var(--font-heading)',
        textShadow: '0 1px 2px rgba(0,0,0,0.3)'
      }}>
      {initials}
    </div>
  );
}
